import { MicrositeEventType } from "@nkr/enums/microsite-event-type";
import { IListItem } from "@nkr/models/list-item";
import { Button, Modal } from "react-bootstrap";

interface IProps {
    eventType: MicrositeEventType,
    patientCount: number,
    show: boolean,
    onCancel: () => void,
    onConfirm: () => void,
    eventTypeList: IListItem[]
}

export default function BulkStatusConfirmation({ eventType, patientCount, show, onCancel, onConfirm, eventTypeList }: IProps) {
    const desc = eventTypeList.find(f => f.id == eventType)?.description;

    return (
        <Modal backdrop='static' show={show} onHide={onCancel}>
            <Modal.Header closeButton>
                <Modal.Title><span>Confirm Status Change</span></Modal.Title>
            </Modal.Header>
            <Modal.Body className='text-center'>
                <p>You are about to change the status for {patientCount} patients!</p>
                <p><strong>{desc}</strong></p>
                <p>If this is correct please click Confirm Changes below.</p>
                <p>If this may be incorrect please click Cancel Changes below.</p>
            </Modal.Body>
            <Modal.Footer>
                <Button bsStyle='primary' onClick={onConfirm}>Confirm Changes</Button>
                <Button onClick={onCancel}>Cancel Changes</Button>
            </Modal.Footer>
        </Modal>
    );
}
